import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout, PMTitleCard } from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";
import { getProjectStatusBadge } from "../../../utils/get-project-status-badge";

/**
 * Adds the report title card and the DC System title card, in that order
 * (#2222).
 */
export function addTitleCards(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const language = app.getAppState().language || "en";

  const titleComponent = view.addComponent({
    component: PMTitleCard,
    layoutProps: {
      componentId: "titleComponent",
      labels: ["report-title"],
      title: getLocalizedMessage(language, "reportTitle") || "Report Title",
      description:
        getLocalizedMessage(language, "reportTitleCardDescription") ||
        "this is the Report Title card.",
    },
  });

  titleComponent.mapState(({ currentReport, settings, language }) => {
    return {
      title: `Dashboard: ${
        currentReport?.project?.customId
          ? currentReport.project.customId + " - "
          : ""
      }${currentReport?.project?.name ?? ""}`,

      showInfoIcon: false,
      showMenuIcon: false,
      badgeConfigs: [
        getProjectStatusBadge({
          currentReport,
          reportingCycle: settings?.configuration?.reportingCycle,
          language: language || "en",
        }),
      ],
    };
  });

  /**
   * Add the DC System title component to the view.
   */
  const itSystemTitleComponent = view.addComponent({
    component: PMTitleCard,
    layoutProps: {
      componentId: "itSystemTitleComponent",
      labels: ["it-system-title"],
      title:
        getLocalizedMessage(language, "itSystemTitle") || "DC System Title",
      description:
        getLocalizedMessage(language, "itSystemTitleCardDescription") ||
        "this is the DC System Title card.",
    },
  });

  itSystemTitleComponent.mapState(({ currentReport, settings, language }) => {
    return {
      title: `DC Business Apps`,

      showInfoIcon: false,
      showMenuIcon: false,
      badgeConfigs: [
        getProjectStatusBadge({
          currentReport,
          reportingCycle: settings?.configuration?.reportingCycle,
          language: language || "en",
        }),
      ],
    };
  });
}
